import React from 'react';
import { classIf } from '../data/utils';

export default function LiveScores(props) {
    const score = props.data;

    let scores = score?.formattedScores ?? null;
    if (scores == null) {
        return null;
    }

    let [game, total, periods] = [null, null, []];
    scores.forEach((s, i) => {
        if (s == null) {
            return;
        }
        if (s.isTotalScore) {
            total = s;
        } else if (game == null && props.sportId === 5) {
            game = s;
        } else {
            periods.push(s);
        }
    });

    return (
        <>
            {periods.map((s, i) => {
                let [c1, c2] = [null, null];
                if (i === (periods.length - 1)) {
                    [c1, c2] = ['yellow', 'yellow'];
                } else {
                    const [n1, n2] = [parseInt(s.s1), parseInt(s.s2)];
                    if (n1 > n2) {
                        c2 = 'grey';
                    } else if (n2 > n1) {
                        c1 = 'grey';
                    }
                }

                return (
                    <div key={i} className="scores-grid">
                        <div className="score-header">{s.p}</div>
                        <div className="score-value" data-color={c1}>{s.s1}</div>
                        <div className="score-value" data-color={c2}>{s.s2}</div>
                    </div>
                );
            })}
            {game ?
                <div className="scores-grid">
                    <div></div>
                    <div className="score-value">{game.s1}</div>
                    <div className="score-value">{game.s2}</div>
                </div>
                :
                <>
                    {total &&
                        <div className="scores-grid">
                            <div></div>
                            <div className="score-value">{total.s1}</div>
                            <div className="score-value">{total.s2}</div>
                        </div>
                    }
                </>
            }
            <div className="service-grid">
                <div></div>
                <div className={"score-service" + classIf(score?.srv === 1, 'active')} />
                <div className={"score-service" + classIf(score?.srv === 2, 'active')} />
            </div>
        </>
    );
}
